import { createSelector } from '@reduxjs/toolkit';
import { getDestinationsState } from '@yme/components/Destinations/redux/selectors';
export const getAmbassadorDetailsPageState = createSelector(getDestinationsState, (state) => state.ambassadorDetailsPage.data);
